import apiAsync from 'infrastructure/shared/api/api-async'

export type PostProcessPayload = {
  processmodel_uuid: string
}

export type ProcessPartial = {
  uuid: string
  situation: string
  uuid_status: string
  version: string
  uuid_User_creation_row: string
  processmodel_uuid: string
  token_uuids: string[]
}

export type PostProcessResponse = {
  success: boolean
  message: string
  data: {
    process: ProcessPartial
  }
}

export const postProcess = (
  payload: PostProcessPayload,
  showLoading = true
): Promise<PostProcessResponse> => {
  return apiAsync.requestSync({
    endpoint: 'msPlatform',
    path: 'processes',
    method: 'POST',
    showLoading: showLoading,
    obj: payload
  })
}
